import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import type { Batch } from '../../../models/Batch';
import type { BatchesModalsRef } from '../modals/BatchesModals';
import { Card } from './Card';

interface CardListProps {
  batches: Batch[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  modalsRef: RefObject<BatchesModalsRef | null>;
}

export const CardList = ({
  batches,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  modalsRef,
}: CardListProps) => {
  const { t } = useTranslation('batchesModule');

  const renderCard = (props: RenderItemProps<Batch>) => <Card {...props} modalsRef={modalsRef} />;

  const getKey = (batch: Batch) => batch.id;

  return (
    <VirtualList
      data={batches}
      renderItem={renderCard}
      itemKey={getKey}
      estimateItemHeight={120}
      height="calc(100vh - 150px)"
      gap={0}
      emptyMessage={t('empty.list')}
      className="rounded-lg shadow-sm"
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
